import type { ReactNode } from "react";

const base = { fill: "none", stroke: "currentColor", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" } as const;

function Svg({ children, size = 34, className }: { children: ReactNode; size?: number; className?: string }) {
  return (
    <svg viewBox="0 0 40 40" width={size} height={size} className={className} aria-hidden {...base}>
      {children}
    </svg>
  );
}

export const IconStar = () => (
  <Svg>
    <path d="M20 6l4.2 9 9.8 1.2-7.2 6.8 1.8 9.7L20 27.7l-8.6 5 1.8-9.7L6 16.2 15.8 15z" />
    <circle cx="20" cy="20" r="2" />
  </Svg>
);

export const IconLotus = () => (
  <Svg>
    <path d="M20 8c3 3 4.5 6.5 4.5 10.5S23 27 20 30c-3-3-4.5-6.5-4.5-11.5S17 11 20 8z" />
    <path d="M11 15c4 .5 7.5 3 9 7m9-7c-4 .5-7.5 3-9 7M6 22c4-.5 8 1 11 4.5M34 22c-4-.5-8 1-11 4.5M12 31c3.5 1.5 6.5 2 8 2s4.5-.5 8-2" />
  </Svg>
);

export const IconClover = () => (
  <Svg>
    <path d="M20 19c-4-1-7-4-7-7.5S16 6 18.5 7s1.5 4 1.5 6c0-2 0-5 1.5-6S27 8.5 27 11.5 24 18 20 19z" />
    <path d="M20 21c-4 1-7 4-7 7.5S16 34 18.5 33s1.5-4 1.5-6c0 2 0 5 1.5 6S27 31.5 27 28.5 24 22 20 21z" />
    <path d="M19 20c-1-4-4-7-7.5-7S6 16 7 18.5s4 1.5 6 1.5c-2 0-5 0-6 1.5S8.5 27 11.5 27 18 24 19 20z" />
    <path d="M21 20c1-4 4-7 7.5-7S34 16 33 18.5s-4 1.5-6 1.5c2 0 5 0 6 1.5S31.5 27 28.5 27 22 24 21 20z" />
  </Svg>
);

export const IconCards = () => (
  <Svg>
    <rect x="8" y="10" width="18" height="24" rx="3" transform="rotate(-8 17 22)" />
    <rect x="15" y="7" width="18" height="24" rx="3" transform="rotate(8 24 19)" />
  </Svg>
);

export const IconBack = () => (
  <Svg size={26}>
    <path d="M25 9l-11 11 11 11" />
  </Svg>
);

export const IconClose = () => (
  <Svg size={26}>
    <path d="M10 10l20 20M30 10L10 30" />
  </Svg>
);

export const IconDownload = () => (
  <Svg size={18}>
    <path d="M20 8v18M12 18l8 8 8-8M8 31h24" />
  </Svg>
);

export const IconShare = () => (
  <Svg size={26}>
    <circle cx="11" cy="20" r="3.5" />
    <circle cx="28" cy="10" r="3.5" />
    <circle cx="28" cy="30" r="3.5" />
    <path d="M14 18.5l11-7M14 21.5l11 7" />
  </Svg>
);

export const IconChevron = () => (
  <Svg size={22}>
    <path d="M10 16l10 10 10-10" />
  </Svg>
);

export const IconHome = () => (
  <Svg>
    <path d="M8 19L20 9l12 10" />
    <path d="M11 17v11h18V17" />
    <path d="M17 28v-7h6v7" />
  </Svg>
);

export const IconDoc = () => (
  <Svg>
    <path d="M13 7h10l5 5v21H13z" strokeLinejoin="round" />
    <path d="M23 7v5h5" />
    <path d="M17 20h9M17 24h9M17 28h6" />
  </Svg>
);

export const IconChat = ({ className }: { className?: string } = {}) => (
  <Svg className={className}>
    <path d="M8 12h20a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H17l-6 5v-5h-3a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3z" strokeLinejoin="round" />
    <circle cx="14.5" cy="19.5" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="20" cy="19.5" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="25.5" cy="19.5" r="1.1" fill="currentColor" stroke="none" />
  </Svg>
);

export const IconSend = () => (
  <Svg>
    <path d="M7 20 32 9 22 33l-4-11-11-2z" strokeLinejoin="round" />
  </Svg>
);

export const IconMic = () => (
  <Svg>
    <rect x="15" y="6" width="10" height="17" rx="5" />
    <path d="M10 18v2a10 10 0 0 0 20 0v-2M20 30v5" />
  </Svg>
);

export const IconPlay = () => (
  <Svg size={18}>
    <path d="M12 8 30 20 12 32Z" strokeLinejoin="round" fill="currentColor" />
  </Svg>
);

export const IconPause = () => (
  <Svg size={18}>
    <path d="M13 8v24M27 8v24" />
  </Svg>
);

export const IconHeart = () => (
  <Svg size={18}>
    <path d="M20 32C9 25 6 18 6 13.5 6 9 9 6 13 6c3 0 5.5 2 7 4.5C21.5 8 24 6 27 6c4 0 7 3 7 7.5C34 18 31 25 20 32z" strokeLinejoin="round" />
  </Svg>
);

export const IconCoin = () => (
  <Svg size={18}>
    <circle cx="20" cy="20" r="13" />
    <path d="M20 13v14M16 17c0-2 1.8-3.5 4-3.5s4 1.3 4 3-1.8 2.5-4 3-4 1.5-4 3 1.8 3 4 3 4-1.5 4-3.5" />
  </Svg>
);

export const IconMoonPath = () => (
  <Svg size={18}>
    <path d="M26 9a13 13 0 1 0 0 22c-6.5-1-11-6-11-11s4.5-10 11-11z" strokeLinejoin="round" />
  </Svg>
);

export const IconFamily = () => (
  <Svg size={18}>
    <circle cx="14" cy="12" r="4.5" />
    <circle cx="26" cy="12" r="4.5" />
    <path d="M6 33c.8-6 4-9.5 8-9.5s7.2 3.5 8 9.5M18 33c.8-6 4-9.5 8-9.5s7.2 3.5 8 9.5" />
  </Svg>
);

export const IconPerson = () => (
  <Svg>
    <circle cx="20" cy="13" r="6" />
    <path d="M8 33c1-7 6-11 12-11s11 4 12 11" />
  </Svg>
);

export const IconGift = ({ className }: { className?: string }) => (
  <Svg className={className}>
    <rect x="8" y="17" width="24" height="16" rx="2" />
    <path d="M8 22h24" />
    <path d="M20 17v16" />
    <path d="M20 17c-2-5-6-6-8-4s0 4 8 4z" />
    <path d="M20 17c2-5 6-6 8-4s0 4-8 4z" />
  </Svg>
);

/** Логотип: звезда в круге (используется как декоративная иконка внутри приложения). */
export function Logo({ className = "logo" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden>
      <circle cx="24" cy="24" r="21" />
      <path d="M24 12l3.2 7 7.6.9-5.6 5.2 1.5 7.5L24 28.6l-6.7 4 1.5-7.5-5.6-5.2 7.6-.9z" strokeLinejoin="round" />
    </svg>
  );
}

/** Фирменный знак: сакральная геометрия из пересекающихся тонких окружностей («цветок жизни»). */
export function BrandMark({ className }: { className?: string }) {
  const r = 9;
  const pts = [
    [0, 0],
    [r * 1.5, 0],
    [-r * 1.5, 0],
    [r * 0.75, r * 1.3],
    [r * 0.75, -r * 1.3],
    [-r * 0.75, r * 1.3],
    [-r * 0.75, -r * 1.3],
  ];
  return (
    <svg className={className} viewBox="-24 -24 48 48" fill="none" stroke="currentColor" strokeWidth="0.9" aria-hidden>
      {pts.map(([x, y]) => (
        <circle key={`${x}-${y}`} cx={x} cy={y} r={r} opacity={0.85} />
      ))}
      <circle cx="0" cy="0" r="21" strokeWidth="1.1" />
    </svg>
  );
}
